import React, { useEffect, useState } from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Card from "react-bootstrap/Card";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Table from "react-bootstrap/Table";
import Badge from "react-bootstrap/Badge";
import axios from "axios";
import { toast } from "react-toastify";

function Dashboard2() {
  const [user, setUser] = useState(null);
  const [selectedDate, setSelectedDate] = useState(new Date().toISOString().split('T')[0]);
  const [livraisons, setLivraisons] = useState([]);
  const [livreurs, setLivreurs] = useState([]);
  const [zones, setZones] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const userData = JSON.parse(localStorage.getItem("userData"));
    if (userData) {
      setUser(userData);
    }
    loadData();
  }, [selectedDate]);

  const loadData = async () => {
    setLoading(true);
    try {
      // Charger les livraisons du jour
      await loadLivraisons();
      // Charger les livreurs disponibles
      await loadLivreurs();
      // Charger les zones
      await loadZones();
    } catch (error) {
      console.error("Erreur lors du chargement des données:", error);
      toast.error("Erreur lors du chargement des données");
    } finally {
      setLoading(false);
    }
  };

  const loadLivraisons = async () => {
    try {
      // TODO: Appel API pour récupérer les livraisons du jour
      // const response = await axios.get(`/api/livraisons?date=${selectedDate}`);
      // setLivraisons(response.data);
      setLivraisons([]); // Placeholder
    } catch (error) {
      console.error("Erreur chargement livraisons:", error);
    }
  };

  const loadLivreurs = async () => {
    try {
      // TODO: Appel API pour récupérer les livreurs disponibles pour cette date
      // const response = await axios.get(`/api/livreurs/disponibles?date=${selectedDate}`);
      // setLivreurs(response.data);
      setLivreurs([]); // Placeholder
    } catch (error) {
      console.error("Erreur chargement livreurs:", error);
    }
  };

  const loadZones = async () => {
    try {
      // TODO: Appel API pour récupérer les zones
      // const response = await axios.get(`/api/zones`);
      // setZones(response.data);
      setZones([]); // Placeholder
    } catch (error) {
      console.error("Erreur chargement zones:", error);
    }
  };

  const handleDateChange = (e) => {
    setSelectedDate(e.target.value);
  };

  return (
    <Container fluid>
      <div className="pb-4 pt-4">
        <h1 className="h1">
          Organisation des Journées de Livraison
        </h1>
        <p className="text-muted">
          Bonjour {user ? `${user.prenom} ${user.nom}` : "Administrateur"}
        </p>
      </div>

      {/* Sélecteur de Date */}
      <Row className="mb-4">
        <Col md={12}>
          <Card>
            <Card.Body>
              <Row className="align-items-center">
                <Col md={3}>
                  <Form.Group>
                    <Form.Label><strong>Date de livraison</strong></Form.Label>
                    <Form.Control
                      type="date"
                      value={selectedDate}
                      onChange={handleDateChange}
                    />
                  </Form.Group>
                </Col>
                <Col md={9} className="d-flex align-items-end">
                  <Button variant="primary" onClick={loadData} disabled={loading}>
                    {loading ? "Chargement..." : "Actualiser"}
                  </Button>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      {/* Vue d'ensemble */}
      <Row className="mb-4">
        <Col md={4}>
          <Card className="h-100">
            <Card.Header className="bg-primary text-white">
              <strong>Livraisons du jour</strong>
            </Card.Header>
            <Card.Body>
              <div className="d-flex justify-content-between align-items-center mb-2">
                <span>Total:</span>
                <Badge bg="primary" pill>{livraisons.length}</Badge>
              </div>
              <div className="d-flex justify-content-between align-items-center mb-2">
                <span>Non assignées:</span>
                <Badge bg="warning" pill>
                  {livraisons.filter(l => !l.livreur_id).length}
                </Badge>
              </div>
              <div className="d-flex justify-content-between align-items-center">
                <span>Assignées:</span>
                <Badge bg="success" pill>
                  {livraisons.filter(l => l.livreur_id).length}
                </Badge>
              </div>
            </Card.Body>
          </Card>
        </Col>

        <Col md={4}>
          <Card className="h-100">
            <Card.Header className="bg-success text-white">
              <strong>Livreurs disponibles</strong>
            </Card.Header>
            <Card.Body>
              <div className="d-flex justify-content-between align-items-center mb-2">
                <span>Total:</span>
                <Badge bg="success" pill>{livreurs.length}</Badge>
              </div>
              <div className="d-flex justify-content-between align-items-center mb-2">
                <span>En service:</span>
                <Badge bg="info" pill>
                  {livreurs.filter(l => l.status === 'en_service').length}
                </Badge>
              </div>
              <div className="d-flex justify-content-between align-items-center">
                <span>Disponibles:</span>
                <Badge bg="success" pill>
                  {livreurs.filter(l => l.status === 'disponible').length}
                </Badge>
              </div>
            </Card.Body>
          </Card>
        </Col>

        <Col md={4}>
          <Card className="h-100">
            <Card.Header className="bg-info text-white">
              <strong>Zones de livraison</strong>
            </Card.Header>
            <Card.Body>
              <div className="d-flex justify-content-between align-items-center mb-2">
                <span>Total zones:</span>
                <Badge bg="info" pill>{zones.length}</Badge>
              </div>
              <div className="d-flex justify-content-between align-items-center">
                <span>Zones actives:</span>
                <Badge bg="success" pill>
                  {zones.filter(z => z.active).length}
                </Badge>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      {/* Liste des Livraisons */}
      <Row className="mb-4">
        <Col md={12}>
          <Card>
            <Card.Header>
              <strong>Livraisons à organiser</strong>
            </Card.Header>
            <Card.Body>
              {livraisons.length === 0 ? (
                <div className="text-center text-muted py-4">
                  <p>Aucune livraison pour cette date</p>
                  <small>Sélectionnez une autre date ou attendez de nouvelles commandes</small>
                </div>
              ) : (
                <Table striped bordered hover responsive>
                  <thead>
                    <tr>
                      <th>Commande</th>
                      <th>Client</th>
                      <th>Adresse</th>
                      <th>Zone</th>
                      <th>Créneau</th>
                      <th>Livreur</th>
                      <th>Statut</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {livraisons.map((livraison) => (
                      <tr key={livraison.id}>
                        <td>#{livraison.commande_id}</td>
                        <td>{livraison.client_nom}</td>
                        <td>{livraison.adresse}</td>
                        <td>
                          <Badge bg="secondary">{livraison.zone_nom || "N/A"}</Badge>
                        </td>
                        <td>{livraison.creneau}</td>
                        <td>
                          {livraison.livreur_nom ? (
                            <Badge bg="success">{livraison.livreur_nom}</Badge>
                          ) : (
                            <Badge bg="warning">Non assigné</Badge>
                          )}
                        </td>
                        <td>
                          <Badge bg={
                            livraison.statut === 'livree' ? 'success' :
                            livraison.statut === 'en_cours' ? 'info' :
                            livraison.statut === 'planifiee' ? 'primary' : 'secondary'
                          }>
                            {livraison.statut}
                          </Badge>
                        </td>
                        <td>
                          <Button variant="outline-primary" size="sm">
                            Assigner
                          </Button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              )}
            </Card.Body>
          </Card>
        </Col>
      </Row>

      {/* Liste des Livreurs */}
      <Row className="mb-4">
        <Col md={12}>
          <Card>
            <Card.Header>
              <strong>Livreurs disponibles</strong>
            </Card.Header>
            <Card.Body>
              {livreurs.length === 0 ? (
                <div className="text-center text-muted py-4">
                  <p>Aucun livreur disponible pour cette date</p>
                  <small>Vérifiez les plannings ou ajoutez des disponibilités</small>
                </div>
              ) : (
                <Table striped bordered hover responsive>
                  <thead>
                    <tr>
                      <th>Livreur</th>
                      <th>Zones assignées</th>
                      <th>Horaires</th>
                      <th>Livraisons assignées</th>
                      <th>Statut</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {livreurs.map((livreur) => (
                      <tr key={livreur.id}>
                        <td>{livreur.nom}</td>
                        <td>
                          {livreur.zones?.map((zone) => (
                            <Badge key={zone.id} bg="secondary" className="me-1">
                              {zone.nom}
                            </Badge>
                          ))}
                        </td>
                        <td>
                          {livreur.heure_debut} - {livreur.heure_fin}
                        </td>
                        <td>
                          <Badge bg="info" pill>{livreur.nb_livraisons || 0}</Badge>
                        </td>
                        <td>
                          <Badge bg={
                            livreur.status === 'en_service' ? 'success' :
                            livreur.status === 'disponible' ? 'info' : 'secondary'
                          }>
                            {livreur.status}
                          </Badge>
                        </td>
                        <td>
                          <Button variant="outline-info" size="sm">
                            Voir tournée
                          </Button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              )}
            </Card.Body>
          </Card>
        </Col>
      </Row>

      {/* Vue par Zone */}
      <Row className="mb-4">
        <Col md={12}>
          <Card>
            <Card.Header>
              <strong>Organisation par zone</strong>
            </Card.Header>
            <Card.Body>
              {zones.length === 0 ? (
                <div className="text-center text-muted py-4">
                  <p>Aucune zone configurée</p>
                </div>
              ) : (
                <Row>
                  {zones.map((zone) => (
                    <Col md={4} key={zone.id} className="mb-3">
                      <Card>
                        <Card.Header className="bg-light">
                          <strong>{zone.nom}</strong>
                          <Badge bg="secondary" className="ms-2">
                            {zone.nb_livraisons || 0} livraisons
                          </Badge>
                        </Card.Header>
                        <Card.Body>
                          <div className="mb-2">
                            <small className="text-muted">Livreurs affectés:</small>
                            <div>
                              {zone.livreurs?.length > 0 ? (
                                zone.livreurs.map((livreur) => (
                                  <Badge key={livreur.id} bg="success" className="me-1 mb-1">
                                    {livreur.nom}
                                  </Badge>
                                ))
                              ) : (
                                <Badge bg="warning">Aucun livreur</Badge>
                              )}
                            </div>
                          </div>
                          <Button variant="outline-primary" size="sm" className="w-100">
                            Gérer la zone
                          </Button>
                        </Card.Body>
                      </Card>
                    </Col>
                  ))}
                </Row>
              )}
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
}

export default Dashboard2;
